export default __webpack_public_path__ + "./images/gde.37ebbb89.png";